module.exports = __webpack_public_path__ + "img/Mike Jones.2d9b5420.jpg";